/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampTripLocationDto } from '../../models/camp-trip-location-dto';
import { CampTripLocationShowResponse } from '../../models/camp-trip-location-show-response';

export interface PostCampTripLocationCreate$Params {
      body: CampTripLocationDto
}

export function postCampTripLocationCreate(http: HttpClient, rootUrl: string, params: PostCampTripLocationCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampTripLocationShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postCampTripLocationCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampTripLocationShowResponse>;
    })
  );
}

postCampTripLocationCreate.PATH = '/v1/camp-trip-location';
